import { IHHOProductItem, ISKUItem } from '@/types/productItem';
import _find from 'lodash/find';
import _flatten from 'lodash/flatten';
import _isEqual from 'lodash/isEqual';
// import { isArrayLooseEqual } from '../compute/isArrayLooseEqual';

export const getProductSoldStock = (variants: ISKUItem[]): number => {
  let soldStock: number =
    variants.reduce((pre, cur) => {
      return pre + cur.inventoryQuantity;
    }, 0) || 0;
  return soldStock;
};

/**
 * @desc 获取剩余的库存
 * @param product
 * @returns
 */
export const getProductRemainStock = (product: IHHOProductItem): number => {
  const { skuList } = product;
  const soldStock = getProductSoldStock(skuList);
  return soldStock;
};

/**
 * @desc 第一个可用的SKU
 */
export const getFirstAbleSKU = (variList: ISKUItem[]): ISKUItem | undefined => {
  const ableVariant = variList.find((item) => item.inventoryQuantity > 0);
  if (!ableVariant && variList && variList.length) {
    return variList[0];
  } else {
    return ableVariant;
  }
};

export const getMinAbluSKU = (
  variList: ISKUItem[],
  disableEcoPurchase,
  defaultSkuId?: string
): ISKUItem | undefined => {
  if (defaultSkuId) {
    for (const item of variList) {
      if (defaultSkuId === item.skuId) {
        return item;
      }
    }
  }
  let minSKu = variList[0];

  for (let i = 1; i < variList.length; i++) {
    // if(min)
    if (disableEcoPurchase) {
      if (minSKu.inventoryQuantity === 0) {
        minSKu = variList[i];
      }
    }
    if (minSKu.price > variList[i].price) {
      minSKu = variList[i];
    }
  }
  return minSKu;
};

/**
 * @desc 根据选项获取购买的单品
 * @param variants
 * @param options
 */
// export const getTargetVariantByOptions = (
//   variants: ISKUItem[],
//   options: string[]
// ): ISKUItem | undefined => {
//   const variant: ISKUItem | undefined = _find(variants, (ele) => {
//     return isArrayLooseEqual(
//       ele.skuOption.map((item) => item.value),
//       options
//     );
//   });
//   return variant;
// };

interface SKUList {
  name: string;
  type: string;
  value: string[];
}

export const handleSKUList = (variants: ISKUItem[], itemSkuOptions: any[]): any => {
  const SKUOptions = variants.map((item) => {
    return item.skuOption;
  });
  let arr: SKUList[] = [];
  itemSkuOptions.map((item) => {
    let data: SKUList = {
      name: item.name,
      type: item.type,
      value: []
    };
    _flatten(SKUOptions).map((option) => {
      if (option.type === item.type && !data.value.includes(option.value)) {
        data.value.push(option.value);
      }
    });
    arr.push(data);
  });
  return arr;
};
export const cereateProductOption = (itemSkuOptions) => {
  let arr = [];
  for (let i = 0; i < itemSkuOptions.length; i++) {
    let item = itemSkuOptions[i];
    arr[i] = {};
    arr[i].name = item.name;
    arr[i].type = item.type;
    arr[i].value = item.attributes;
  }
  return arr;
};

// 多variants时纠正
export const getDiffSKUList = (lastSkuItem, options, skuList) => {
  const existSKU = skuList.map((item) => item.skuOption.map((sku) => sku.value));
  let flag = false;
  let diffItem;
  const lastSKUValue = lastSkuItem.skuOption.map((sku) => sku.value);
  existSKU.map((item) => {
    if (_isEqual(item, options)) {
      flag = true;
    }
  });
  if (flag) {
    return options;
  } else {
    lastSKUValue.map((item, index) => {
      if (lastSKUValue[index] !== options[index]) {
        diffItem = options[index];
      }
    });
    const newOptions = existSKU.find((item) => item.includes(diffItem));
    return newOptions;
  }
};

export const getSelectSKU = (optionList, skuList) => {
  for (let item of skuList) {
    let total = 0;
    for (let i = 0; i < optionList.length; i++) {
      if (optionList[i] === item.skuOption[i].value) {
        total += 1;
      }
    }
    if (total === optionList.length) {
      return item;
    }
  }
  //   skuList.filter((item) => {
  //     for (let i = 0; i < item.skuOption.length; i++) {
  //       let child = item.skuOption[i];
  //       debugger;
  //       return child.value === optionList[i];
  //     }
  //   });
};
